/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import isObject from"./isObject";import isString from"./isString";import some from"./some";const deepSearch=function(e,t){if(!isObject(e)||!isString(t))return;let r=e;return some(t.split("."),(e=>(r=r[e],!r))),r};export default deepSearch;